import { IAlertsDashboardStoreSegment } from './alertsDashboard.interface';

export const alertsDashboardStoreSelector = (state: IAlertsDashboardStoreSegment) => state.alertsDashboard;
